// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"d50b5119","123":"84b1c6c2","746":"cd836c7a","874":"643e5ef4","929":"7ad840fe","965":"33078016","992":"4d408602"}[chunkId] + ".chunk.js";
};